import env from '../core/env'
import { sdk } from './importPaySDK'
import bridge from '../bridge'
import { openWxPayPage, openAlipayPayPage } from './openMpPay'

function uni (opts) {
  if (env.is('passenger')) {
    bridge.openUniPay({...opts, ...opts.pay}, function (res) {
      if (res.code === 1) {
        opts.success && opts.success(res)
      } else if (res.code === 2) {
        opts.cancel && opts.cancel(res)
      } else {
        opts.fail && opts.fail(res)
      }
    })
  } else if (env.is('weixin.miniprogram')) {
    // 微信小程序 TODO
    openWxPayPage(opts)
  } else if (env.is('alipay.miniprogram')) {
    // 支付宝小程序 TODO
    openAlipayPayPage(opts)
  } else {
    sdk(opts, function (err) {
      opts.fail && opts.fail(err)
    })
  }
}

export default uni
